<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,100;1,200;1,300&display=swap");

*,
html,
body {
  font-family: "Poppins", sans-serif;
}
</style>

<script>
export default {
  name: "App",
};
</script>
